var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GChart',{attrs:{"id":"map-chart","type":_vm.type,"data":_vm.data,"options":_vm.options,"settings":_vm.settings,"resizeDebounce":1000}})
}
var staticRenderFns = []

export { render, staticRenderFns }